import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { EnumUtil } from '@csp/csp-common-enum-util';
import { EthnicityType, Maybe, UserPersonal, toGenderType } from '@csp/csp-common-model';
import { PersonalV1 } from '@csp/dmdp-api-user-dto';

const fromPersonalV1 = (personal: Maybe<PersonalV1>): UserPersonal => ({
  gender: toGenderType(personal?.gender),
  ethnicity: EnumUtil.fromMaybeStringOrDefault(personal?.ethnicity, EthnicityType, EthnicityType.UNKNOWN),
  birthDate: personal?.birthDate,
  birthYear: personal?.birthYear,
  createdAt: personal?.createdAt
    ? ZonedDateTimeFactory.fromZonedDateTimeString(personal.createdAt)
    : ZonedDateTimeFactory.fromUnixTimeMillis(0),
  createdBy: personal?.createdBy,
  previousPersonals: (personal?.previousPersonals ?? []).map(previousPersonal => ({
    gender: toGenderType(previousPersonal?.gender),
    ethnicity: EnumUtil.fromMaybeStringOrDefault(previousPersonal?.ethnicity, EthnicityType, EthnicityType.UNKNOWN),
    birthDate: previousPersonal?.birthDate,
    birthYear: previousPersonal?.birthYear,
    createdAt: previousPersonal?.createdAt
      ? ZonedDateTimeFactory.fromZonedDateTimeString(previousPersonal.createdAt)
      : ZonedDateTimeFactory.fromUnixTimeMillis(0),
  })),
});

export const UserPersonalMapper = {
  fromPersonalV1,
};
